var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tCard"},[_c('div',{staticClass:"tCard-header"},[_vm._t("title")],2),_c('div',{staticClass:"tCard-wrapper"},[_c('div',{staticClass:"tCard-body"},[_vm._t("extra")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }